import React from "react";
import { Pressable, Text, Platform } from "react-native";
import tw from "twrnc";

const AppTitle = ({
  text,
  h1,
  h2,
  h3,
  h4,
  h5,
  onPress,
  style,
  containerStyle,
}) => {
  // Base text styles with Tailwind
  const getTextStyles = () => {
    const baseStyles = tw`font-bold text-[#2E3F52]`;

    if (h1) {
      return tw.style(baseStyles, "text-3xl leading-20");
    } else if (h2) {
      return tw.style(baseStyles, "text-2xl leading-8");
    } else if (h3) {
      return tw.style(baseStyles, "text-xl leading-7");
    } else if (h4) {
      return tw.style(baseStyles, "text-lg leading-6");
    } else if (h5) {
      return tw.style(baseStyles, "text-base leading-5");
    } else {
      // Default to h1
      return tw.style(baseStyles, "text-3xl leading-9 web:leading-[110%]");
    }
  };

  const TextComponent = () => (
    <Text style={[getTextStyles(), style]}>{text}</Text>
  );

  return onPress ? (
    <Pressable style={containerStyle} onPress={onPress}>
      <TextComponent />
    </Pressable>
  ) : (
    <TextComponent />
  );
};

export default AppTitle;
